var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportMergeLconfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C2.17157 1 1.5 1.67157 1.5 2.5C1.5 3.32843 2.17157 4 3 4C3.82843 4 4.5 3.32843 4.5 2.5C4.5 1.67157 3.82843 1 3 1ZM3 0C4.20948 0 5.21836 0.85888 5.44999 2H9C9.78689 2 10.5279 2.37049 11 3L13.1 5.8C13.1944 5.9259 13.3426 6 13.5 6H18.7929L15.6464 2.85355C15.4512 2.65829 15.4512 2.34171 15.6464 2.14645C15.8417 1.95118 16.1583 1.95118 16.3536 2.14645L20.3536 6.14645C20.5488 6.34171 20.5488 6.65829 20.3536 6.85355L16.3536 10.8536C16.1583 11.0488 15.8417 11.0488 15.6464 10.8536C15.4512 10.6583 15.4512 10.3417 15.6464 10.1464L18.7929 7H13.5C13.0279 7 12.5833 6.77771 12.3 6.4L10.2 3.6C9.91672 3.22229 9.47214 3 9 3H5.44999C5.21836 4.14112 4.20948 5 3 5C1.61929 5 0.5 3.88071 0.5 2.5C0.5 1.11929 1.61929 0 3 0ZM1.5 10.5C1.5 9.67157 2.17157 9 3 9C3.82843 9 4.5 9.67157 4.5 10.5C4.5 11.3284 3.82843 12 3 12C2.17157 12 1.5 11.3284 1.5 10.5ZM3 8C4.20948 8 5.21836 8.85888 5.44999 10H9.03875C9.49443 10 9.9254 9.79287 10.2101 9.43704L11.5 8C11.6725 7.78437 11.9872 7.74941 12.2028 7.92191C12.4184 8.09442 12.4534 8.40906 12.2809 8.62469L11 10C10.5256 10.593 9.79821 11 9.03875 11H5.44999C5.21836 12.1411 4.20948 13 3 13C1.61929 13 0.5 11.8807 0.5 10.5C0.5 9.11929 1.61929 8 3 8Z",
    fill: "#818183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportMergeLconfig);
export default __webpack_public_path__ + "static/media/import_merge_lconfig.dcf08cf8f70bafd8a1ae85df764c100f.svg";
export { ForwardRef as ReactComponent };